import { ObservableFromFetch } from "../ObservableFromFetch"

export default function RemoveDuplicateRoles(userName: string) {
  const requestBody: string = new URLSearchParams({ UserName: userName.toString() }).toString()
  return ObservableFromFetch<string>("WorkforceSuperUser/RemoveDuplicateRoles?" + requestBody, "post")
}
